const transformDuplicates = ({ data }) => {
  const { candidates } = data;

  return candidates;
};

export { transformDuplicates };
